/* eslint-disable perfectionist/sort-objects, no-magic-numbers */
/**
 * Copied and made some change based on radix-themes-tw
 * https://github.com/viktorbonino/radix-themes-tw/blob/main/src/index.ts
 *
 * Radix Token:
 * https://github.com/radix-ui/themes/tree/main/packages/radix-ui-themes/src/styles/tokens
 *
 * Tailwind Token:
 * https://github.com/tailwindlabs/tailwindcss/blob/master/stubs/config.full.js
 */

import { Config } from "tailwindcss";
import defaultConfig from "tailwindcss/defaultConfig";

import { getThemeColors } from "./utils.get-theme-colors";
import { getThemeSpacing } from "./utils.get-theme-spacing";

const { theme } = defaultConfig;

const tailwindTheme = {
  ...theme,

  fontFamily: {
    sans: ["var(--default-font-family)"],
    serif: ["var(--heading-font-family)"],
    mono: ["var(--code-font-family)"],
  },
  borderRadius: {
    none: "0",
    1: "var(--radius-1)",
    2: "var(--radius-2)",
    3: "var(--radius-3)",
    4: "var(--radius-4)",
    5: "var(--radius-5)",
    6: "var(--radius-6)",
    full: "9999px",
  },
  boxShadow: {
    // radix
    1: "var(--shadow-1)",
    2: "var(--shadow-2)",
    3: "var(--shadow-3)",
    4: "var(--shadow-4)",
    5: "var(--shadow-5)",
    6: "var(--shadow-6)",
    none: "0 0 #0000",
  },
  colors: getThemeColors(),
  fontSize: {
    // radix
    1: "var(--font-size-1)",
    2: "var(--font-size-2)",
    3: "var(--font-size-3)",
    4: "var(--font-size-4)",
    5: "var(--font-size-5)",
    6: "var(--font-size-6)",
    7: "var(--font-size-7)",
    8: "var(--font-size-8)",
    9: "var(--font-size-9)",
  },
  fontWeight: {
    DEFAULT: "400",

    thin: "100",
    extralight: "200",
    // 300
    light: "var(--font-weight-light)",
    // 400
    normal: "var(--font-weight-regular)",
    regular: "var(--font-weight-regular)",
    // 500
    medium: "var(--font-weight-medium)",
    // 600
    semibold: "600",
    // 700
    bold: "var(--font-weight-bold)",
    extrabold: "800",
  },
  letterSpacing: {
    1: "var(--letter-spacing-1)",
    2: "var(--letter-spacing-2)",
    3: "var(--letter-spacing-3)",
    4: "var(--letter-spacing-4)",
    5: "var(--letter-spacing-5)",
    6: "var(--letter-spacing-6)",
    7: "var(--letter-spacing-7)",
    8: "var(--letter-spacing-8)",
    9: "var(--letter-spacing-9)",
  },
  lineHeight: {
    1: "var(--line-height-1)",
    2: "var(--line-height-2)",
    3: "var(--line-height-3)",
    4: "var(--line-height-4)",
    5: "var(--line-height-5)",
    6: "var(--line-height-6)",
    7: "var(--line-height-7)",
    8: "var(--line-height-8)",
    9: "var(--line-height-9)",
  },
  screens: {
    // https://www.radix-ui.com/themes/docs/theme/breakpoints
    // https://tailwindcss.com/docs/responsive-design
    // it almost the same but radix start with `xs` while tailwind start with `sm`
    xxs: "360px",
    xs: "520px",
    sm: "768px",
    md: "1024px",
    lg: "1280px",
    xl: "1640px",
  },
  spacing: getThemeSpacing(),
  animation: {
    "accordion-down": "accordion-down 0.2s ease-out",
    "accordion-up": "accordion-up 0.2s ease-out",
    "grow-loop": "grow-loop 5s linear infinite",
  },
  keyframes: {
    "accordion-down": {
      from: { height: "0" },
      to: { height: "var(--radix-accordion-content-height)" },
    },
    "accordion-up": {
      from: { height: "var(--radix-accordion-content-height)" },
      to: { height: "0" },
    },
    "grow-loop": {
      "0%": { transform: "scaleX(0)" },
      "100%": { transform: "scaleX(1)" },
    },
  },
} as const satisfies Config["theme"];

export { tailwindTheme };
